<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="warehouseRegisters"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn"/>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="发起人">
            <el-input v-model.trim="filter.creatorName" placeholder="请输入发起人" clearable/>
          </el-form-item>
          <el-form-item label="快递单号">
            <el-input v-model.trim="filter.courierNo" placeholder="请输入发起人" clearable/>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
          </el-form-item>
          <el-form-item label="发起时间">
            <el-date-picker
                v-model="createTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createTimeRange', 'beginCreateTime', 'endCreateTime')"/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <warehouse-pre-registration-edit ref="warehousePreRegistrationEdit" @save-success="loadData"/>
    <warehouse-pre-registration-preview ref="warehousePreRegistrationPreview"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import WarehousePreRegistrationEdit from "@/views/StoreManagement/WarehousePreRegistration/WarehousePreRegistrationEdit";
  import WarehousePreRegistrationPreview from "@/views/StoreManagement/WarehousePreRegistration/WarehousePreRegistrationPreview";

  export default {
    name: "WarehousePreRegistrationList",
    components: {
      WarehousePreRegistrationEdit, 
      WarehousePreRegistrationPreview,
      viewTable,
    },
    data() {
      return {
        limits: {
          addAuth: this.$auth(27),
          editAuth: this.$auth(27),
          delAuth: this.$auth(64),
        },
        createTimeRange: [],
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        selection: [],
        filter: {
          creatorName: "",
          customerName: "",
          beginCreateTime: "",
          endCreateTime: "",
        },
        columnsProperty: [
          {
          tooltip: true,
            key: "billNo",
            align: "center",
            width: 220,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.viewHandle(params.row);
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
          tooltip: true,
            key: "creatorName",
            align: "center",
            width: 100,
            label: "发起人",
          },
          {
          tooltip: true,
            key: "createTime",
            align: "center",
            label: "发起时间",
          },
          {
          tooltip: true,
            key: "associationNo",
            align: "center",
            label: "关联售后单号",
          },
          {
          tooltip: true,
            key: "expressCompany",
            align: "center",
            label: "快递公司",
          },
          {
          tooltip: true,
            key: "expressNo",
            align: "center",
            label: "快递单号",
          },
          {
          tooltip: true,
            key: "customerName",
            align: "center",
            label: "客户名称",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.warehousePreRegistrationEdit.open(row);
      },
      viewHandle(row) {
        this.$refs.warehousePreRegistrationPreview.open(row);
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      deleteHandle(row) {
        this.$http.delete("basic", "warehouseRegisters", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      selectHandle(selection) {
        this.selection = selection;
      },
      resetHandle(filter) {
        this.filter = filter;
      },
    },
  };
</script>